import CharacterSelection from "../../components/CharacterSelection";
import useTokenAndProfile from "../../components/hooks/FetchUserProfile";
import PrivateLayout from "../../layouts/PrivateLayout";

const Account = () => {
  const backgroundImage = "/ww-wallpaper.webp";
  const { token } = useTokenAndProfile();

  return (
    <PrivateLayout backgroundImage={backgroundImage}>
      <CharacterSelection token={token} />
    </PrivateLayout>
  );
};

export default Account;
